import { render, staticRenderFns } from "./user_password.vue?vue&type=template&id=2e833d0f&scoped=true&"
import script from "./user_password.vue?vue&type=script&lang=js&"
export * from "./user_password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e833d0f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e833d0f')) {
      api.createRecord('2e833d0f', component.options)
    } else {
      api.reload('2e833d0f', component.options)
    }
    module.hot.accept("./user_password.vue?vue&type=template&id=2e833d0f&scoped=true&", function () {
      api.rerender('2e833d0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/pos/oauth/user_password.vue"
export default component.exports